import { useContext, useMemo } from 'react'

import { FormControl, MenuItem, Select} from '@mui/material'

import { AppContext } from '/providers/app-context'
import { getCurrentTemplateId, setCurrentTemplateId } from '/utils/current-template'

const TemplateSelector = ({ templateId = '', onChange, fullWidth = false }) => {
  const { templates = [] } = useContext(AppContext)
  const activeTemplates = useMemo(
    () => templates.filter(template => !template.archived).sort((first, second) => (first.name || '').localeCompare(second.name || '')),
    [templates]
  )
  const storedTemplateId = getCurrentTemplateId()
  const selectedTemplateId = templateId
    ? String(templateId)
    : activeTemplates.some(template => String(template.template_id) === String(storedTemplateId))
      ? String(storedTemplateId)
      : ''

  return (
    <FormControl size="small" sx={{ minWidth: 320, ...(fullWidth ? { width: '100%' } : {}) }}>
      <Select
        value={selectedTemplateId}
        onChange={event => {
          const nextTemplateId = event.target.value
          setCurrentTemplateId(nextTemplateId)
          onChange(nextTemplateId)
        }}
        displayEmpty
        renderValue={selected => activeTemplates.find(template => String(template.template_id) === String(selected))?.name || 'Choose template'}
        >
        <MenuItem value="" disabled>Choose template</MenuItem>
        {activeTemplates.map(template => (
          <MenuItem key={template.template_id} value={String(template.template_id)}>{template.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default TemplateSelector
